// Single source of truth derived dynamically from REACT_APP_CONTACT_PHONE in .env
const rawPhone = (process.env.REACT_APP_CONTACT_PHONE || "99753 40919").trim();
const digitsOnly = rawPhone.replace(/\D/g, "");
const last10 = digitsOnly.length >= 10 ? digitsOnly.slice(-10) : digitsOnly;
const formatted5x5 = last10.length === 10 ? `${last10.slice(0, 5)} ${last10.slice(5)}` : rawPhone;

export const CONTACT_PHONE = formatted5x5;
export const CONTACT_PHONE_INTL = `+91 ${formatted5x5}`;
export const CONTACT_PHONE_TEL = `+91${last10}`;
export const WHATSAPP_PHONE = `91${last10}`;
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL || "hr@sagveektechnologies.in";
